import { SlideObject, createObjectId } from '../types';
import { cloneChartData } from './chartModel';
import { cloneTableData } from './tableModel';

export const NUDGE_STEP = 1;
export const NUDGE_STEP_LARGE = 8;

export function nudgeOffset(key: string, shift = false): { dx: number; dy: number } | null {
  const step = shift ? NUDGE_STEP_LARGE : NUDGE_STEP;
  if (key === 'ArrowLeft') return { dx: -step, dy: 0 };
  if (key === 'ArrowRight') return { dx: step, dy: 0 };
  if (key === 'ArrowUp') return { dx: 0, dy: -step };
  if (key === 'ArrowDown') return { dx: 0, dy: step };
  return null;
}

export function resolveShiftAxis(
  dx: number,
  dy: number,
  existing: 'x' | 'y' | null
): 'x' | 'y' | null {
  if (existing) return existing;
  if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return null;
  return Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
}

export function constrainMoveDelta(
  dx: number,
  dy: number,
  axis: 'x' | 'y' | null
): { dx: number; dy: number } {
  if (axis === 'x') return { dx, dy: 0 };
  if (axis === 'y') return { dx: 0, dy };
  return { dx, dy };
}

export function cloneSlideObject(
  object: SlideObject,
  siblings: SlideObject[],
  offset = { x: 0, y: 0 }
): SlideObject {
  return {
    ...object,
    id: createObjectId(object.type),
    x: object.x + offset.x,
    y: object.y + offset.y,
    z: Math.max(0, ...siblings.map((item) => item.z || 0)) + 1,
    locks: { ...object.locks },
    style: object.style ? { ...object.style } : undefined,
    table: object.type === 'table' ? cloneTableData(object.table) : object.table,
    chart: object.type === 'chart' ? cloneChartData(object.chart) : object.chart,
  };
}
